/**
 * 模型与供应商页面共用的小工具：价格字符串去尾零、JSON 文本框解析与回显、币种符号。
 *
 * 背景：已发布模型、渠道模型库、各自的编辑表单都要处理「库里是定点小数、界面要去掉多余的 0」与「复杂价目用 JSON 编辑」。
 * 设计意图：只放纯函数；校验由后端 Decimal 与 Alice 的校验函数裁决，前端只检查是不是合法 JSON。
 * 关键约束：空串表示未配置（返回 fallback），不合法时抛出带字段名的错误。
 */
import type { ModelKind } from '@ap/api-client/types'

export const KINDS: ModelKind[] = ['chat', 'embedding', 'image', 'video', 'speech', 'transcription', 'music', 'audio']
export const SYMBOL = { USD: '$', CNY: '¥' } as const

/** 库里的价格是定点小数（带多余的 0），界面上去掉末尾的 0 方便读；null 显示成空串。 */
export const num = (v: string | null | undefined) => (v == null ? '' : v.includes('.') ? v.replace(/0+$/, '').replace(/\.$/, '') : v)
export const orNull = (v: string) => (v.trim() === '' ? null : v.trim())

export function parseJson<T>(name: string, text: string, fallback: T, badJson: (name: string) => string): T {
  if (!text.trim()) return fallback
  try {
    return JSON.parse(text) as T
  } catch {
    throw new Error(badJson(name))
  }
}
export const showJson = (v: unknown, empty: boolean) => (empty || v == null ? '' : JSON.stringify(v, null, 2))
export const isEmptyObj = (v: unknown) => v == null || (typeof v === 'object' && Object.keys(v as object).length === 0)
